import { isThemeToken } from '@nettbureau/theme';
import { isNumber } from 'radash';

/**
 * Parses the given width into a CSS width value.
 *
 * @param theme - The theme object.
 * @param width - The width to resolve a value for.
 */ function parseWidth(theme, width) {
    return isNumber(width) ? theme.scales.base * width : isThemeToken(width, theme.widths) ? theme.widths[width] : width;
}

export { parseWidth };
//# sourceMappingURL=width.js.map
